import { initializeApp } from "firebase/app"
import { getAnalytics } from "firebase/analytics";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import {
        getAuth,
        signInWithEmailAndPassword,
        updateEmail,
        sendPasswordResetEmail,
        verifyBeforeUpdateEmail,
        sendEmailVerification,
        signOut,
} from "firebase/auth"
import {
        getFirestore,
        doc,
        setDoc,
} from "firebase/firestore"
import { getStorage } from "firebase/storage"

function showNotification(message) {
        const notification = document.getElementsByClassName("notification")[0];
        if (notification) {
            notification.textContent = message;
            notification.classList.add("animated");
    
            // Automatically hide notification after 5 seconds
            setTimeout(() => {
                notification.classList.remove("animated");
                notification.style.top = "-900px"; // Reset position
            }, 5000);
        } else {
            console.error("Notification element not found");
        }
    }

const firebaseConfig = {
        apiKey: "AIzaSyCXp9s1vBlm1HnAf4tC83g5AbfabBy0F2U",
        authDomain: "bluebird-documentation.firebaseapp.com",
        projectId: "bluebird-documentation",
        storageBucket: "bluebird-documentation.appspot.com",
        messagingSenderId: "65293049615",
        appId: "1:65293049615:web:077b2757723651e3cda87a",
        measurementId: "G-0Z24RWEJ2Y"
};

const app = initializeApp(firebaseConfig)
const analytics = getAnalytics(app);

// Initialize Firebase App Check - TEMPORARILY DISABLED
// IMPORTANT: Add your reCAPTCHA v3 site key to .env file as REACT_APP_RECAPTCHA_SITE_KEY
// Get this from: https://console.cloud.google.com/security/recaptcha
// Also enable App Check in Firebase Console: https://console.firebase.google.com/project/bluebird-documentation/appcheck
/*
if (typeof window !== 'undefined') {
        const appCheck = initializeAppCheck(app, {
                provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'), // Uses test key as fallback
                isTokenAutoRefreshEnabled: true // Automatically refresh tokens
        });
        console.log('Firebase App Check initialized - bot protection active');
}
*/

const auth = getAuth(app)
const db = getFirestore(app)
const storage = getStorage(app)

const loginWithEmailAndPassword = async (email, password) => {
        try {
                await signInWithEmailAndPassword(auth, email, password)        
        } catch (err) {
                showNotification(err.message)
        }
}

const updateUserEmail = async (newEmail) => {
        try {
            const user = auth.currentUser;
            if (!user) {
                showNotification("No user is signed in.");
                return;
            }
    
            // Send a verification email to the new email address
            await verifyBeforeUpdateEmail(user, newEmail);
            showNotification("A verification email has been sent. Please confirm the change by clicking the link in your email.");
    
            // Email will only be updated once the user clicks the verification link
    
        } catch (err) {
            showNotification(err.message);
        }
    };
    

const registerWithEmailAndPassword = async (name, email, password, turnstileToken) => {
        try {
                // Account creation goes through the backend instead of the
                // Firebase client SDK so the Turnstile captcha token can be
                // verified server-side (BBD-72).
                const registerResponse = await fetch("https://bluebirddocumentationadmin.pythonanywhere.com/users/register/", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ name, email, password, turnstileToken })
                })

                if (!registerResponse.ok) {
                        const data = await registerResponse.json().catch(() => ({}))
                        // Mirror the Firebase SDK error shape so callers keep working
                        return {
                                error: {
                                        code: data.code === "EMAIL_EXISTS" ? "auth/email-already-in-use" : (data.code || "registration-failed"),
                                        message: data.error || "Registration failed. Please try again."
                                }
                        }
                }

                const res = await signInWithEmailAndPassword(auth, email, password)
                const user = res.user

                // Send email verification immediately
                await sendEmailVerification(user)
                
                await setDoc(doc(db, "users", user.uid), {
                        uid: user.uid,
                        name,
                        authProvider: "local",
                        email,
                        emailVerified: false
                })
                
                showNotification("Account created! Please check your email and verify your address before continuing.")
                return user.uid
        } catch (err) {
                // Return error object instead of just showing notification
                // This allows the caller to handle specific error types
                return { error: err }
        }
}

const sendPasswordReset = async (email) => {
        try {
                await sendPasswordResetEmail(auth, email)
                showNotification("Password reset link sent!")
        } catch(err) {
                showNotification(err)
        }
}

const logout = () => { signOut(auth) }

// Function to resend email verification
const resendEmailVerification = async () => {
        try {
                const user = auth.currentUser;
                if (user && !user.emailVerified) {
                        await sendEmailVerification(user);
                        showNotification("Verification email sent! Please check your inbox.");
                        return true;
                } else if (user && user.emailVerified) {
                        showNotification("Your email is already verified.");
                        return false;
                } else {
                        showNotification("No user is currently signed in.");
                        return false;
                }
        } catch (err) {
                showNotification("Failed to send verification email: " + err.message);
                return false;
        }
}

export {
        auth,
        db,
        storage,
        loginWithEmailAndPassword,
        registerWithEmailAndPassword,
        sendPasswordReset,
        logout,
        updateUserEmail,
        showNotification,
        resendEmailVerification,
}